import { Components, Theme } from "@mui/material";
export const muiStackTheme = (
    theme: Theme,
): Pick<Components<Omit<Theme, "components">>, "MuiStack"> => ({
    MuiStack: {},
});
